import React from 'react';
import PropertyCard from './PropertyCard';
import PropertyModal from './PropertyModal';
import { properties } from '../data/mock';
import { Building2 } from 'lucide-react';

const PropertiesSection = () => {
    const [properties, setProperties] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedProperty, setSelectedProperty] = React.useState(null);

  React.useEffect(() => {
    
     fetch(`${process.env.REACT_APP_API_URL}/inmogar/admin/properties`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data)
        setProperties(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error cargando propiedades:", err);
        setLoading(false);
      });
  }, []);

  return (
    <section id="propiedades" data-testid="property-listings" className="py-24 sm:py-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block text-[#D4A520] font-medium text-sm uppercase tracking-[0.2em] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Propiedades
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-5 tracking-tight">
            Propiedades Destacadas
          </h2>
          <div className="w-16 h-[1px] bg-[#D4A520] mx-auto mb-6" />
          <p className="text-white/50 text-base max-w-2xl mx-auto" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Descubre las mejores opciones en zonas de alta plusvalía en Piura
          </p>
        </div>

        {/* Properties Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {properties.map((property) => (
            <PropertyCard
              key={property.id}
              property={property}
              onViewDetails={setSelectedProperty}
            />
          ))}
        </div>
      </div>

      {/* Property Modal */}
      <PropertyModal
        property={selectedProperty}
        isOpen={!!selectedProperty}
        onClose={() => setSelectedProperty(null)}
      />
    </section>
  );
};

export default PropertiesSection;
